import { useParams } from 'react-router'

export const SpaceSettingsSidebar = () => {
  const params = useParams()
  return <p>Space Id: {params?.id}</p>
}
